import React, { useEffect } from 'react';
import { useDatadogLog } from '../../hooks/useDatadogLog';
import { useLocation } from 'react-router';
import { useSession } from '../../providers/Session.provider';
import { useClientLogin } from '../../providers/ClientLogin.provider';
import { useLogTimestamp } from '@/providers/LogTimestamp.provider';

export default function PageNavLogger({ children }: { children: React.ReactNode }) {
  const { isAuthenticated } = useClientLogin();
  const { datadogLog } = useDatadogLog();
  const { appendUniqueId } = useSession();
  const location = useLocation();
  const { lastVisitedTimestamp, updateTimestamp } = useLogTimestamp();

  useEffect(() => {
    appendUniqueId();
    const currentTime = Date.now();
    if (isAuthenticated)
      datadogLog({
        message: `Navigated to ${location.pathname}`,
        payload: {
          label: location.pathname,
          value: location.pathname,
          visitDuration: (currentTime - lastVisitedTimestamp) / 1000,
        },
        actionType: 'Navigation',
      });
    updateTimestamp(currentTime);
  }, [location.pathname]);

  return <>{children}</>;
}
